import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import ModalityForm from '../components/forms/ModalityForm';
import '../styles/EmployeeMaster.css';
import ModalityTable from '../components/ModalityTable';

const ModalityModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/modality/add';

  const handleAddClick = () => {
    navigate('/modality/add');
  };

  const handleCloseModal = () => {
    navigate('/modality');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Modality Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Modality
        </button>
      </div>

      <ModalityTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Modality</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalityForm />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalityModel;
